/* eslint-disable no-param-reassign */
import { h, render } from 'preact';
import ProductGrid from '../product-grid/product-grid';
import './bundle-builder.css';

export const getUniqueID = () =>
  (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}_${Math.floor(Math.random() * 10000)}`;

export default (element, data) => {
  const addAllBundleItemsBtn = element.querySelector('[data-add-bundle-items-to-cart]');

  // track items as they are selected and removed from bundle builder
  let allSelectedItems = [];
  const updateTotalCount = (action, product = {}, stepIndex = 1) => {
    const countersToUpdate = document.querySelectorAll('.header-count');

    if (action === 'add') {
      product.index = stepIndex;
      if (product.qty < 2) {
        allSelectedItems = [...allSelectedItems, product];
      } else {
        const prodArray = [];

        for (let index = 0; index < product.qty; index += 1) {
          prodArray.push(product);
        }

        allSelectedItems = [...allSelectedItems, ...prodArray];
      }
    } else if (action === 'clear') {
      allSelectedItems.length = 0;
    } else {
      let itemRemovedArray;

      // ultimately, we only want to remove one but the same product might exist multiple times so we need to check for that
      if (allSelectedItems.some((item) => item.multi === true)) {
        const multiItems = allSelectedItems.filter((p) => p.multi === true);
        const nonMultiItems = allSelectedItems.filter((p) => p.multi === false);

        if (multiItems.some((i) => parseInt(i.id, 10) === parseInt(product.id, 10))) {
          const itemsReduced = multiItems.slice(0, -1);
          allSelectedItems = [...nonMultiItems, ...itemsReduced];
        } else {
          itemRemovedArray = allSelectedItems.filter((item) => parseInt(item.id, 10) !== parseInt(product.id, 10));
          allSelectedItems = [...itemRemovedArray];
        }
      } else {
        itemRemovedArray = allSelectedItems.filter((item) => parseInt(item.id, 10) !== parseInt(product.id, 10));
        allSelectedItems = [...itemRemovedArray];
      }
    }

    // update the counters in the bundle builder page header
    countersToUpdate.forEach((counter) => {
      if (action === 'add') {
        counter.innerText = allSelectedItems.length;
      } else if (action === 'clear') {
        counter.innerText = 0;
      } else {
        // minus
        counter.innerText = allSelectedItems.length;
      }
    });

    if (allSelectedItems.length === data.totalRequiredProductsForPromo) {
      addAllBundleItemsBtn.removeAttribute('disabled');
    } else {
      addAllBundleItemsBtn.setAttribute('disabled', 'true');
    }
  };

  const init = () => {
    // eslint-disable-next-line no-new
    // new SwiperCarousel('.bundle-builder-page-swiper', {
    //   slidesPerView: 2.75,
    //   spaceBetween: 15,
    //   breakpoints: {
    //     768: {
    //       slidesPerView: 'auto'
    //     }
    //   },
    //   scrollbar: {
    //     el: '.bundle-builder-page-swiper-scrollbar',
    //     draggable: true,
    //   }
    // });

    // output the product grid for each category (categories are section blocks)
    data.collections.forEach((collection, index) => {
      const entryPoint = element.querySelector(`#bundle_builder_product_grid_${index}`);
      render(
        <ProductGrid
          {...collection}
          bundleBuilder={true}
          bundleBuilderCategory={index + 1}
          updateTotalCount={(action, product) => updateTotalCount(action, product, index)}
        />,
        entryPoint,
      );
    });

    addAllBundleItemsBtn.addEventListener('click', () => {
      const itemsForCart = [];
      const bundleId = getUniqueID();
      const mainProduct = allSelectedItems.find((item) => item.index === 0);
      itemsForCart.push({
        id: data.parentId ? `gid://shopify/ProductVariant/${data.parentId}` : mainProduct.firstVariantId,
        quantity: 1,
        attributes: [
          {
            key: '_bundle_id',
            value: bundleId,
          },
          {
            key: '_bundle_image',
            value: `${data.bundlePrice}`,
          },
          {
            key: '_bundle_url',
            value: window.location.href,
          },
          ...(data.bundleImage
            ? [
                {
                  key: '_bundle_image',
                  value: `${data.bundleImage}`,
                },
              ]
            : []),
          {
            key: '_bundle_uid',
            value: data.uid,
          },
          {
            key: '_bundle_data',
            value: JSON.stringify({
              items: allSelectedItems.map((item) => ({
                id: parseInt(item.firstVariantId.split('/').pop(), 10),
                qty: 1,
                title: item.title,
                cl: item.collection,
                uid: item.uid,
              })),
              type: data.bundleTitle,
              image: mainProduct.image,
            }),
          },
        ],
      });

      const addToCartEvent = new CustomEvent('cart:add', {
        detail: {
          payload: itemsForCart,
        },
      });

      document.dispatchEvent(addToCartEvent);

      const bundleBuilderClearAllItemsBtn = document.querySelector('[data-clear-all-bundle-items]');
      bundleBuilderClearAllItemsBtn.click();
    });
  };

  init();
};
